module.exports = __webpack_public_path__ + "img/news-mobile.2c396838.png";